import * as React from 'react';
import { cn } from '../../../../utils';
import { ChevronDown } from '../../../atoms/icons';
import type { ComplexTreeItemChevronProps } from '../types';

export const ComplexTreeItemChevron: React.FC<ComplexTreeItemChevronProps> = ({ item, isExpanded }) => {
	if (item.index === 'root') return null;

	const hasChildren = item.children && item.children.length > 0;

	return (
		<div className={'chevron-bg flex justify-center'} data-testid="complex-tree-item-chevron">
			<div
				className={cn(
					'inline-flex h-[2rem] w-[2rem] items-center justify-center transition-transform duration-100 ease-in-out',
					hasChildren && !isExpanded && '-rotate-90 text-secondary',
					hasChildren && isExpanded && 'text-primary'
				)}
			>
				{hasChildren && <ChevronDown />}
			</div>
		</div>
	);
};
